import { localeLabel } from "@/lib/locale";
// Locale-aware display labels for the `professionals.availability` enum.
// The stored/compared VALUE stays English (it's the DB value + drives the
// pill colour via string equality in the cards/profile); only the visible
// label localizes — same pattern as categories/provinces. VI is a MACHINE
// DRAFT pending the native reviewer; FR falls back to EN.
//
// Canonical values live in `src/lib/actions/availability.ts` (that file is
// "use server", so the label map can't live there).

const AVAILABILITY_LABELS_FR: Record<string, string> = {
  "Available now — accepting new clients": "Disponible — accepte de nouveaux clients",
  "Limited availability — contact to enquire": "Disponibilité limitée — nous contacter",
  "Fully booked — waitlist only": "Complet — liste d'attente uniquement",
};

const AVAILABILITY_LABELS_VI: Record<string, string> = {
  "Available now — accepting new clients": "Đang nhận khách mới",
  "Limited availability — contact to enquire": "Còn ít chỗ — liên hệ để hỏi",
  "Fully booked — waitlist only": "Đã kín lịch — chỉ nhận danh sách chờ",
};

// Keys are the stored English values and must match them byte for byte.
const AVAILABILITY_LABELS_ZH_HANS: Record<string, string> = {
  "Available now — accepting new clients": "现可接受新客户",
  "Limited availability — contact to enquire": "名额有限，请咨询",
  "Fully booked — waitlist only": "已约满，仅接受候补",
};

// Generated from the zh-Hans table by `toTraditional`; fix meaning there, not here.
const AVAILABILITY_LABELS_ZH_HANT: Record<string, string> = {
  "Available now — accepting new clients": "現可接受新客戶",
  "Limited availability — contact to enquire": "名額有限，請諮詢",
  "Fully booked — waitlist only": "已約滿，僅接受候補",
};

/** Display label for an availability value (VI, FR and zh machine drafts; other → EN). */
export function getAvailabilityLabel(value: string, locale: string): string {
  return localeLabel(locale, value, value, {
    vi: AVAILABILITY_LABELS_VI,
    fr: AVAILABILITY_LABELS_FR,
    "zh-Hans": AVAILABILITY_LABELS_ZH_HANS,
    "zh-Hant": AVAILABILITY_LABELS_ZH_HANT,
  });
}
